var map = {
	"./ac/ac.jpg": 2235,
	"./ac/ac1.jpg": 6346,
	"./aluminum/aluminum-1.jpg": 9592,
	"./aluminum/aluminum.jpg": 1923,
	"./container/container-1.jpg": 1081,
	"./container/container-2.jpeg": 9099,
	"./copper/copper-1.jpg": 3647,
	"./copper/copper-2.jpeg": 1935,
	"./industrial/industrial-1.jpg": 7860,
	"./industrial/industrial-2.webp": 4032,
	"./metal/metal-2.webp": 2553,
	"./metal/metal.jpg": 4057,
	"./pic_1.jpg": 5914,
	"./pic_2.jpg": 683,
	"./pic_3.jpg": 907,
	"./pic_4.jpg": 2206,
	"./pic_5.jpg": 1433,
	"./pic_6.jpg": 9489,
	"./steel/steel-1.jpg": 7616,
	"./steel/steel-2.jpg": 6912,
	"./yard/yard-2.jpg": 7009,
	"./yard/yard.jpg": 5057
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1561;